
import HeaderButton from '~/components/Header/Button.vue'
import HeaderContact from '~/components/Header/HomeContact.vue'
import HeaderRecruit from '~/components/Header/HomeRecruit.vue'
import { enableScroll } from '~/plugins/helper'
import GradualBlur from '~/sections/top/gradual-blur.vue'

import Header from '@/components/Header/home.vue'
import NavMegaMenu from '@/components/Header/NavMegaMenu.vue'

export default {
  components: {
    Header,
    HeaderButton,
    HeaderContact,
    HeaderRecruit,
    GradualBlur,
    NavMegaMenu
  },
  computed: {
    isShowMenu() {
      return this.$store.state.isShowMenu
    }
  },
  watch: {
    $route: {
      handler() {
        this.onRouteChange()
      },
      immediate: false
    }
  },
  mounted() {
    // isShowMenuはレイアウト間で共有されるため読み込み時に閉じる(SSRで動くcreated()は避ける)
    this.$store.commit('SET_MENU', false)
    enableScroll()

    // loadイベントがmounted()より前に発火済みの場合リスナーが呼ばれないため、読み込み完了済みならその場でfinish()を呼ぶ
    const onLoaded = () => {
      setTimeout(() => {
        this.$nuxt.$loading.finish()
        this.onRouteChange()
      }, 200)
    }

    if (document.readyState === 'complete') {
      onLoaded()
    } else {
      window.addEventListener('load', onLoaded)
    }
  },
  methods: {
    onRouteChange() {
      // Listen for route changes and scroll to hash section if present
      if (this.$route.hash) {
        const targetElement = document.getElementById(this.$route.hash.substring(1) + '-section')
        if (targetElement) {
          window.setTimeout(() => {
            this.$scrollTo(targetElement, { offset: -100 })
          }, 500)
        }
      }
    }
  }
}
